<template>
  <form @submit.prevent="validateAndSubmit" novalidate>
    <b-field
      :type="{ 'is-danger': errors.has('password') }"
      :message="errors.first('password')"
    >
      <b-input
        name="password"
        v-model="user.password"
        type="password"
        placeholder="Senha"
        password-reveal
        key="password-input"
        v-validate="{
          required: true,
          regex: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,16}$/,
        }"
        ref="password"
        data-vv-as="senha"
        maxlength="16"
      />
    </b-field>

    <b-field
      :type="{ 'is-danger': errors.has('confirmPassword') }"
      :message="errors.first('confirmPassword')"
    >
      <b-input
        name="confirmPassword"
        v-model="user.confirmPassword"
        type="password"
        placeholder="Confirmar senha"
        password-reveal
        key="confirm-input"
        data-vv-as="confirmar senha"
        v-validate="'confirmed:password'"
      />
    </b-field>

    <p class="verify-password-title">A senha deve conter pelo menos:</p>

    <ul class="verify-password">
      <li>
        <b-icon
          size="is-small"
          icon="check"
          :type="{
            'is-success': passwordHasAlpha,
            'is-white': !passwordHasAlpha,
          }"
        />
        1 letra
      </li>
      <li>
        <b-icon
          size="is-small"
          icon="check"
          :type="{
            'is-success': passwordHasNumber,
            'is-white': !passwordHasNumber,
          }"
        />
        1 número
      </li>
      <li>
        <b-icon
          size="is-small"
          icon="check"
          :type="{
            'is-success': user.password.length >= 6,
            'is-white': user.password.length < 6,
          }"
        />
        6 caracteres
      </li>
    </ul>

    <b-button expanded native-type="submit" type="is-primary"
      >Cadastrar</b-button
    >
  </form>
</template>

<script>
export default {
  data() {
    return {
      user: {
        password: "",
        confirmPassword: "",
      },
    };
  },
  computed: {
    passwordHasAlpha() {
      return (
        this.user.password && /^(?=.*[a-zA-Z]).+$/.test(this.user.password)
      );
    },
    passwordHasNumber() {
      return this.user.password && /^(?=.*\d).+$/.test(this.user.password);
    },
  },
  methods: {
    validateAndSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit("onConfirm", {
            password: this.user.password,
          });
        } else {
          this.$buefy.toast.open({
            message: "Verfique os campos marcados para continuar.",
            type: "is-danger",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.help {
  margin-top: -0.35rem;
  margin-bottom: 0.5rem;
}

.verify-password {
  display: flex;
  flex-direction: column;
  margin: 0 0 2rem 0;
  padding: 0;

  li {
    color: white;
    font-size: 0.9rem;
    line-height: 1.5rem;
    gap: 0.6rem;
    padding-left: 0.6rem;

    display: inline-flex;
    align-items: center;

    .icon > svg {
      border: 1px solid red;
    }
  }
}

.verify-password-title {
  color: white;
  margin-top: 1.5rem;
}
</style>

<style lang="scss">
.verify-password {
  .svg,
  .icon > svg {
    width: 1rem !important;
    height: 1rem !important;
  }
}
</style>
